import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import cn from '../../libs/class-name'
import logo from '../../assets/images/logo.svg'
import logoInvert from '../../assets/images/logo-invert.svg'

const Logo = ({ classNames, alt, invert = false, size = 'base' }) => (
  <Link
    className={cn('Logo', { invert, [`size-${size}`]: true }, classNames)}
    to="/"
  >
    <img className="Logo__img" src={invert ? logoInvert : logo} alt={alt} />
  </Link>
)

Logo.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  alt: PropTypes.string,
  invert: PropTypes.bool,
  size: PropTypes.oneOf(['base', 'l'])
}

export default Logo
